import { getIterableArrayOfObjects } from 'shared/utils/getIterableArrayOfObjects';

import {
  type SeriaPlusSlideMarker,
  type SeriaPlusSlideMarkerScheme,
  type SeriaPlusSlideScheme,
  type SeriaPlusTabScheme,
} from '../seriaPlusTypes';

export const SERIA_PLUS_V3_IMAGE_BASE_URL =
  'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v3';

export function createDescription(lines: string[]): Pick<SeriaPlusSlideScheme, 'description' | 'descriptionLines'> {
  return {
    description: lines.join(' '),
    descriptionLines: lines,
  };
}

export function createSlideMarkers(markers: SeriaPlusSlideMarkerScheme[]): SeriaPlusSlideMarker[] {
  return getIterableArrayOfObjects<SeriaPlusSlideMarkerScheme>(markers);
}

export function createTab(tab: { slides: SeriaPlusSlideScheme[]; title: string }): SeriaPlusTabScheme {
  return {
    slides: getIterableArrayOfObjects<SeriaPlusSlideScheme>(tab.slides),
    title: tab.title,
  };
}
